module.exports = __webpack_public_path__ + "static/media/logo.80f4e6ce.png";